import { render } from "./wxDetail.vue?vue&type=template&id=f39fa7a0&scoped=true"
import script from "./wxDetail.vue?vue&type=script&lang=js"
export * from "./wxDetail.vue?vue&type=script&lang=js"

import "./wxDetail.vue?vue&type=style&index=0&id=f39fa7a0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39fa7a0"]])

export default __exports__